import {BaseButtonProps, Button} from './button';

type CustomButtonProps = Omit<BaseButtonProps, 'className'>;

const CancelButton = (props: CustomButtonProps) => <Button className={styles.cancelButton} {...props} />;
const CancelButtonFilled = (props: CustomButtonProps) => <Button className={styles.cancelButtonFilled} {...props} />;

const ConfirmButton = (props: CustomButtonProps) => <Button className={styles.confirmButton} {...props} />;
const ConfirmButtonFilled = (props: CustomButtonProps) => <Button className={styles.confirmButtonFilled} {...props} />;

const StyledPrintButton = (props: CustomButtonProps) => <Button className={styles.styledPrintButton} {...props} />;

export {
  CancelButton,
  CancelButtonFilled,
  ConfirmButton,
  ConfirmButton as RescheduleButton,
  ConfirmButtonFilled,
  StyledPrintButton,
};

const styles = {
  cancelButton: 'button border-red text-red enabled:hover:bg-red',
  cancelButtonFilled: 'button bg-red hover:bg-red-hover text-white',

  confirmButton: 'button border-blue text-blue enabled:hover:bg-blue',
  confirmButtonFilled: 'button bg-blue hover:bg-blue-hover text-white',

  styledPrintButton:
    'flex items-center gap-3 bg-light-gray rounded-md py-2 pl-4 pr-[0.4rem] transition-colors duration-200 ease-in-out text-[0.9em] cursor-pointer hover:bg-gray-hover',
};
